export const marketPulseEnabled = process.env?.REACT_APP_MARKET_PULSE_ENABLED === "1";

export const mailingAddressEnabled = process.env?.REACT_APP_MAILING_ADDRESS_ENABLED === "1";